"use strict";
import a from "./index.es99.js";
import n from "./index.es109.js";
import t from "./index.es145.js";
function d(e, i) {
  return n(e, new t.classes.URLSearchParams(), {
    visitor: function(r, s, f, o) {
      return t.isNode && a.isBuffer(r) ? (this.append(s, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...i
  });
}
export {
  d as default
};
//# sourceMappingURL=index.es144.js.map
